import React from 'react';
import queryString from 'query-string';
import '../../../../scss/PublicView/Pages/Home.scss'
import axios from 'axios';
import { ROOT_API_URL } from '../../../../api-config'
import { Input } from '@progress/kendo-react-inputs';

export default class SetupPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordConfirm: '',
            resetToken: '',
            email: '',
            id: '',
            success: false,
            sent: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getUserIdAndTokenFromParams();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    getUserIdAndTokenFromParams() {
        const parsed = queryString.parse(this.props.location.search);

        this.setState({
            id: parsed.id,
            resetToken: parsed.token
        })
    }

    handleSubmit(event) {
        this.setState({
            success: ''
        });
        console.log(this.state)

        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json;charset=UTF-8'
            }
        };

        axios.post(`${ROOT_API_URL}/account/resetpassword`,
            {
                id: this.state.id,
                Password: this.state.password,
                ResetToken: this.state.resetToken
            },
            config).then(response => {
                console.log(response)
                if (response && response.data && !response.data.isSuccess) {
                    this.setState({
                        success: response.data.isSuccess,
                        sent: true
                    });
                } 
            }, error => {
                this.setState({
                    success: false,
                    sent: false
                });
            });
        event.preventDefault();
    }


    render() {
        const confirmPasswordValidationMessage = "Passwords do not match!";
        const passwordValidation = `Passwords must be between 6 and 18 characters, 
                                    have at least one non-alphanumeric character, 
                                    one digit ('0'-'9'), 
                                    one uppercase ('A'-'Z'), and 
                                    one lowercase ('a'-'z').`;
        const passwordRegex = `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{6,}$`;

        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent reset-password">
                    <div className="container-fluid">
                        <h1>
                           Setup Your Password
                        </h1>
                    
                        {(this.state.success === false) ? <p> Choose and confirm the new password.</p> : <p>Password successfully setup. Please SIGN IN to your account.</p>}
                    
                        <div >
                        {(this.state.success === false) ?
                            <form className="menuLogin createAccountForm" onSubmit={this.handleSubmit}>
                                <div className="labelField form-group">
                                    <label>Password</label>

                                    <Input
                                        type="password"
                                        name="password"
                                        id="registerPassword"
                                        value={this.state.password}
                                        required={true}
                                        minLength={6}
                                        maxLength={18}
                                        pattern={passwordRegex}
                                        placeholder="Enter Password"
                                        onChange={this.handleInputChange}
                                        validationMessage={passwordValidation} />
                                </div>
                                <div className="labelField form-group">
                                    <label>Confirm Password</label>

                                    <Input
                                        type="password"
                                        required={true}
                                        name="passwordConfirm"
                                        valid={this.state.password && this.state.password === this.state.passwordConfirm}
                                        validationMessage={confirmPasswordValidationMessage}
                                        id="confirmRegisterPassword"
                                        value={this.state.passwordConfirm}
                                        placeholder="Confirm Password"
                                        onChange={this.handleInputChange} />
                                </div>
                                <div className="homeBtnContainer form-group">
                                    <div className="v-space"></div>
                                    <button className='btnPrimary btn-block labelFieldSize' type="submit">Submit</button>
                                </div>

                            </form> : null }
                        </div>
                       
                        <p> {(this.state.success === false && this.state.sent === true) ? `Password setup unsuccessful. Please try again.` : null }</p>

                    </div>
                </div>
            </div>
        )
    }
}